import { satellite } from './satellite.js';
import type { Branded } from './brandedTypes.js';
import type { Lang } from './langs.js';

export type AffinityTid = Branded<string, 'AffinityTid'>;

export type TopicAffinityName = Branded<string, 'TopicAffinityName'>;

export type ProductAffinityName = Branded<string, 'ProductAffinityName'>;

export type AffinitiesDict = {
  topics: Record<AffinityTid, Record<Lang, TopicAffinityName>>;
  products: Record<AffinityTid, Record<Lang, ProductAffinityName>>;
};

export class AffinitiesService {
  /**
   * Map of affinity tids to affinity names
   */
  public affinityDict?: AffinitiesDict;

  constructor() {
    if (window.drupalSettings?.rhdc_myrh?.taxonomy) {
      this.affinityDict = window.drupalSettings?.rhdc_myrh?.taxonomy;
    }
  }

  /**
   * Get the top 5 topic affinites for
   * this user.
   */
  async getTopicAffinities(lang: Lang = 'en'): Promise<TopicAffinityName[]> {
    if (this.affinityDict === undefined || typeof this.affinityDict?.topics !== 'object') {
      console.warn(`AffinitiesService: no topic affinity dictionary found.`);
      return [];
    }
    const dict = this.affinityDict.topics;
    const ret: TopicAffinityName[] = [];
    for (let i = 1; i < 6; i++) {
      try {
        const tid = await satellite.getVar(`topicAffinity${i}`) as AffinityTid | undefined;
        if (!tid) { break; }
        const name = dict[tid]?.[lang];
        if (name) {
          ret.push(name);
          continue;
        }
        break;
      } catch (error) {
        console.warn(`Error getting topic affinity ${i}:`, error);
        break;
      }
    }
    return ret;
  }
}
